import { includes, isEqual, partial } from 'lodash-es';
import { z } from 'zod';

function createEnv() {
  const envSchema = z.object({
    API_URL: z.string().optional(),
    DEBUG_TANSTACK_ROUTER: z.string()
      .refine(partial(includes, ['true', 'false']))
      .transform(partial(isEqual, 'true'))
      .optional(),
    DEBUG_TANSTACK_QUERY: z.string()
      .refine(partial(includes, ['true', 'false']))
      .transform(partial(isEqual, 'true'))
      .optional(),
    OIDC_AUDIENCE: z.string().min(1),
    OIDC_AUTHORITY: z.string().min(1),
    OIDC_CLIENT_ID: z.string().min(1)
  });

  const envVars = Object.entries(import.meta.env)
    .reduce<Record<string, string>>((final, current) => {
      const [key, value] = current;

      if (key.startsWith('VITE_')) {
        final[key.replace('VITE_', '')] = value;
      }

      return final;
    }, {});

  const parsedEnv = envSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided:
      The following keys are missing or invalid:
      ${Object.entries(parsedEnv.error.flatten().fieldErrors).map(([key, value]) => `${key}: ${value}`).join('\n')}
      `
    );
  }

  return parsedEnv.data;
}

export const env = createEnv();
